/* eslint-disable react-hooks/exhaustive-deps */

import React, { useRef, useEffect, useState } from 'react';
import { currencyFormat, downloadImageCommon, exportChatFile } from "../../../../helpers/utilities";
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../Icons/selectedIcon";
import { Image, Dropdown, Menu, Row, Col } from "antd";
import { NavLink } from "react-router-dom";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import useMediaQuery from '@mui/material/useMediaQuery';

export const BestSellingProducts = (props) => {
    const { title, details } = props;
    const bestSellingProducts = useRef(null);
    const classes = customStyles();
    const [datas, setDatas] = useState([]);
    const [type, setType] = useState('top_saled_product_15');
    const [sort, setSort] = useState('totalQuantity');
    const mobileDevice = useMediaQuery('(min-width:1300px)');
    let cI = 0;
    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(bestSellingProducts.current, title, type);
        }
    }

    const exportFile = () => {
        let newHead = [
            ['Product Name', 'Quantity', 'Unit', 'Amount']
        ];

        datas && datas.length > 0 && datas.map((d, i) => {
            return newHead[i + 1] = [d.name, d.totalQuantity, d.unit, d.totalAmount];
        });
        exportChatFile(title, newHead);
    }

    const handleChange = (value) => {
        details[value].sort((a, b) => b[sort] - a[sort]);
        setType(value);
        setDatas(details[value]);
    }

    useEffect(() => {
        if (details['top_saled_product_15']?.length > 0) {
            setDatas(details['top_saled_product_15']?.sort((a, b) => b[sort] - a[sort]));
        }
    }, [details]);

    const handleSortChange = (value) => {
        setSort(value);
        details[type].sort((a, b) => b[value] - a[value]);
        setDatas(details[type]);
    }

    return (
        <div ref={bestSellingProducts} className={clsx(classes.totalChartDiv, classes.topProductSupply, { [classes.mobileDevice]: !mobileDevice })}>
            <div className={clsx(classes.monthlyDivTitle, classes.bold)}
            ><span>{title}</span>
                <span className={classes.lastDaysRadioSupply}>
                    <RadioGroup
                        row
                        defaultValue={"totalQuantity"}
                        value={sort}
                        onChange={(e) => handleSortChange(e.target.value)}>
                        <FormControlLabel style={{ width: 86 }} value="totalQuantity" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="By Quantity" />
                        <FormControlLabel value="totalAmount" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="By Value" />
                    </RadioGroup>
                    <RadioGroup
                        row
                        defaultValue={type}
                        onChange={(e) => handleChange(e.target.value)}>
                        <FormControlLabel style={{ width: 86 }} value="top_saled_product_15" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="15 days" />
                        <FormControlLabel value="top_saled_product_30" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="30 days" />
                        <FormControlLabel style={{ width: 86 }} value="top_saled_product_more_30" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="> 30 days" />
                        <FormControlLabel value="top_saled_product_today" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="Today" />
                    </RadioGroup>
                </span>
                <span className={classes.hamburgerMenu}>
                    <Dropdown
                        placement="bottomLeft"
                        trigger={['click']}
                        overlay={
                            <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                            </Menu>
                        }>
                        <Image src={hamburgerMenu} preview={false} />
                    </Dropdown>
                </span>
            </div>
            <div className={classes.topProductSupplyContent}>
                {
                    datas && datas.length > 0 ? datas.map((d, i) => {
                        if (cI >= 3) {
                            cI = 0;
                        }
                        cI += 1;
                        return (
                            <Row key={i} gutter={10}>
                                <Col span="24">
                                    <div className={clsx(classes.textFieldColor, classes.fonSize13, classes.bold)}>{d?.name || '---'}</div>
                                    {/* <div className={clsx(classes.textFieldColor, classes.fonSize13)}>{d?.productId || '---'}</div> */}
                                    <div className={clsx({ [classes.product_bg_green]: cI === 1 }, { [classes.product_bg_blue]: cI === 2 }, { [classes.product_bg_yellow]: cI === 3 }, classes.padding5)}>
                                        <Row gutter={10}>
                                            <Col span="4">
                                                <div className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink')}>Quantity</div>
                                                <div className={clsx(classes.textFieldColor, classes.fonSize13)}>{d?.totalQuantity || '---'}</div>
                                            </Col>
                                            <Col span="6">
                                                <div className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink')}>Unit</div>
                                                <div className={clsx(classes.textFieldColor, classes.fonSize13)}>{d?.unit || '---'}</div>
                                            </Col>
                                            <Col span="14">
                                                <div className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink', classes.textAlignRight)}>Amount</div>
                                                <div className={clsx(classes.textFieldColor, classes.fonSize13, classes.textAlignRight)}>{d?.totalAmount ? '₹ ' + currencyFormat(d?.totalAmount) : '---'}</div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        )
                    }) : <Row key={'No products'} gutter={10}>
                        <Col span="24" className={clsx(classes.noResultsText, classes.textAlignCenter)}>Data Will be Displayed when transactions are recorded by the system</Col>
                    </Row>
                }
            </div>
        </div>
    )
}